export default __webpack_public_path__ + "static/media/market-blue.c1f0c531.svg";